import { isMobile } from '@kizi/comparator-components';
import { Div, P } from '@kizi/core-components';
import React from 'react';

export const NonPurchasableText = (): JSX.Element => {
  return (
    <Div
      variant="unavailablePriceContainer"
      mt={isMobile() ? 0 : null}
      maxWidth={isMobile() ? 'unset' : '180px'}
      textAlign={'center'}
    >
      <P variant="secondaryCaptionBold">
        {isMobile()
          ? 'Niet af te sluiten'
          : 'Niet af te sluiten omdat dit je huidige provider is'}
      </P>
    </Div>
  );
};
